// src/modules/LiberaProximaVenda/services/branchService.js
import { fetchData } from '../../../utils/datasource';

/**
 * Fetches the list of branches/companies from the API
 * @returns {Promise<Array>} Array of branch objects with id and name properties
 * @throws {Error} If the API request fails
 */
export const fetchBranches = async () => {
  try {
    const response = await fetchData('/api/framework/environment/v1/branches?pageSize=100', 'GET');
    
    if (!response.ok) {
      throw new Error('Failed to fetch branches');
    }
    
    const result = await response.json();
    
    // Transform API response to match the component's expected format
    // Filter only branches with CompanyCode = "01"
    const branches = result.items
      .filter((item) => item.CompanyCode === '01')
      .map((item) => ({
        id: item.Code,
        name: `${item.Code} - ${item.Description}`
      }));
    
    return branches;
  } catch (error) {
    console.error('Error fetching branches:', error);
    throw error;
  }
};
